import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild} from '@angular/core';
import * as Chart from 'chart.js';
import * as _ from 'lodash';

export const REF_C = {
    accent: '#5A55F5', soft: '#C9C6FC', mid: '#8B87F8', dark: '#3E38D6', green: '#16865A', greenS: '#9ED9BF',
    amber: '#E0A12B', red: '#D92D4B', blue: '#2563EB', gray: '#C3C7D4', ink: '#1F2233', muted: '#646A80', line: '#E7E8F0'
};

/** Draws text in the middle of a doughnut (Chart.js 2 plugin). */
export function centerText(text: string | number, size = 15, sub = ''): any {
    return {
        afterDraw(c: any) {
            const {ctx, chartArea: {left, right, top, bottom}} = c;
            const x = (left + right) / 2, y = (top + bottom) / 2;
            ctx.save();
            ctx.fillStyle = REF_C.ink;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = `600 ${size}px Montserrat, Helvetica, Arial, sans-serif`;
            ctx.fillText(String(text), x, y - (sub ? 8 : 0));
            if (sub) {
                ctx.font = '400 12px Montserrat, Helvetica, Arial, sans-serif';
                ctx.fillStyle = REF_C.muted;
                ctx.fillText(sub, x, y + 12);
            }
            ctx.restore();
        }
    };
}

const BASE_OPTIONS = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {duration: 500},
    legend: {labels: {usePointStyle: true, boxWidth: 8, padding: 14, fontColor: REF_C.muted}},
    tooltips: {backgroundColor: REF_C.ink, xPadding: 10, yPadding: 10, cornerRadius: 8}
};

/** Thin Chart.js 2 wrapper: pass a full chart config, it redraws on change. */
@Component({
    selector: 'app-ref-chart',
    template: '<canvas #canvas [attr.aria-label]="label" role="img"></canvas>',
    styles: [':host{display:block;position:relative;height:100%;width:100%}']
})
export class RefChartComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() config: any;
    @Input() label = '';
    @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
    private chart: any;

    ngAfterViewInit() {
        this.draw();
    }

    ngOnChanges() {
        if (this.canvas) {
            this.draw();
        }
    }

    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    private draw() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
        if (!this.config) {
            return;
        }
        const cfg = {...this.config, options: _.merge({}, BASE_OPTIONS, this.config.options)};
        this.chart = new (Chart as any)(this.canvas.nativeElement, cfg);
    }
}
